
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';

const pageConfig = (window as any).pageConfig;

const initialState = {
    filters: pageConfig.categories != null ? pageConfig.categories.split(',') : [],
}

const filtersSlice = createSlice({
    name: 'filters',
    initialState,
    reducers: {
        updateFilter(state, action: PayloadAction<string>) {
            // Avoid duplicate filters
            if (!state.filters.includes(action.payload)) {
                state.filters.push(action.payload);
            }
        },

        removeFilter(state, action: PayloadAction<string>) {
            state.filters = state.filters.filter((filter) => filter !== action.payload);
        },

        clearFilters(state) {
            state.filters = [];
        },
    },
},
)

export const { updateFilter, removeFilter, clearFilters } = filtersSlice.actions

export default filtersSlice.reducer